const copyStringToClipboard = async (string, cb) => {
  if (string == null || string === "") return false;
  if (!navigator?.clipboard?.writeText) return false;

  try {
    await navigator.clipboard.writeText(String(string));
    if (cb) cb();
    return true;
  } catch (err) {
    if (typeof console !== "undefined") {
      console.warn("copyStringToClipboard failed", err);
    }
    return false;
  }
};

// iOS Safari revokes the user-activation gesture as soon as an async handler
// awaits anything, which causes a later navigator.clipboard.writeText to be
// silently rejected. Passing a Promise to ClipboardItem keeps the gesture
// alive while the string resolves — this is the Safari-documented workaround.
export const copyAsyncString = async (textPromise, fallbackText) => {
  if (typeof ClipboardItem !== "undefined" && navigator?.clipboard?.write) {
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/plain": Promise.resolve(textPromise)
            .then(
              (text) =>
                new Blob([String(text ?? fallbackText ?? "")], {
                  type: "text/plain",
                })
            )
            .catch(
              () =>
                new Blob([String(fallbackText ?? "")], { type: "text/plain" })
            ),
        }),
      ]);
      return true;
    } catch (err) {
      if (typeof console !== "undefined") {
        console.warn("copyAsyncString ClipboardItem write failed", err);
      }
    }
  }

  try {
    const resolved = await Promise.resolve(textPromise).catch(() => null);
    const finalText = resolved ?? fallbackText;
    if (!finalText) return false;
    return await copyStringToClipboard(finalText);
  } catch {
    return false;
  }
};

export default copyStringToClipboard;
